import React from "react";

import defaultIconProps from "@/constants/defaultIconProps";
import IconProps from "@/types/icons/IconProps";

const ArrowLeftIcon: React.FC<IconProps> = (props) => {
  const { width, height, fontSize, color } = {
    ...defaultIconProps, ...props
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      height={height}
      width={width}
      style={{ fontSize }}
      {...props}
    >
      <path
        d="M7.8499 13L10.6999 15.85C10.8999 16.05 10.9957 16.2833 10.9874 16.55C10.9791 16.8167 10.8832 17.05 10.6999 17.25C10.4999 17.45 10.2624 17.5542 9.9874 17.5625C9.7124 17.5708 9.4749 17.475 9.2749 17.275L4.6999 12.7C4.4999 12.5 4.3999 12.2667 4.3999 12C4.3999 11.7333 4.4999 11.5 4.6999 11.3L9.2749 6.72501C9.4749 6.52501 9.7124 6.42918 9.9874 6.43751C10.2624 6.44585 10.4999 6.55001 10.6999 6.75001C10.8832 6.95001 10.9791 7.18335 10.9874 7.45001C10.9957 7.71668 10.8999 7.95001 10.6999 8.15001L7.8499 11H18.9999C19.2832 11 19.5207 11.0958 19.7124 11.2875C19.9041 11.4792 19.9999 11.7167 19.9999 12C19.9999 12.2833 19.9041 12.5208 19.7124 12.7125C19.5207 12.9042 19.2832 13 18.9999 13H7.8499Z"
        fill={color}
      />

    </svg>
  );
};

export default ArrowLeftIcon;
